@if (dateForm) {
  <form class="grid grid-cols-1 gt-sm:grid-cols-5 grid-rows-1 gap-2 justify-stretch" [formGroup]="dateForm">
    <mat-form-field class="col-span-2">
      <mat-label>Date from (DOE)</mat-label>
      <input matInput type="date" formControlName="from" />
      <mat-error>
        {{ getDateInputError(dateFromControl) }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="col-span-2">
      <mat-label>Date to (DOE)</mat-label>
      <input matInput type="date" formControlName="to" />
      <mat-error>
        {{ getDateInputError(dateToControl) }}
      </mat-error>
    </mat-form-field>
    <div class="flex flex-col gap-2">
      <button mat-raised-button type="button" (click)="selectPresetDateRange(-1)">Previous month</button>
      <button mat-raised-button type="button" (click)="selectPresetDateRange(0)">Current month</button>
    </div>
  </form>
} @else {
  <app-loading-spinner></app-loading-spinner>
}
